import axios from 'axios';
import namespace from './namespace';
import FieldsMappingService from './../../../service/fieldsMapping.js';
import AppService from './../../../service/app.js';
import { NAMESPACE as APP_NAMESPACE } from './../app';

let service = new FieldsMappingService(axios);
let appService = new AppService();
const ERROR_MESSAGE_TITLE = 'Operation failed';

export default {
    async [namespace.actions.GET_AVAILABLE_VALUES] ({ commit, dispatch }) {     
        try {
            commit(namespace.mutations.SHOW_LOADER, true);  
            commit(namespace.mutations.SET_MAPPINGS_VALUES, await service.getData());       
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },

    async [namespace.actions.MAP] ({ commit, state, dispatch }, payload) {
        try {   
            commit(namespace.mutations.SHOW_LOADER, true);  
            commit(namespace.mutations.SET_MAPPINGS_VALUES, await service.addMapping(
                payload.jiraField,
                payload.tfsField,
                state[namespace.state.AVAILABLE_JIRA_VALUES],
                state[namespace.state.AVAILABLE_TFS_VALUES],
                state[namespace.state.MAPPINGS_GROUPS]
            ));
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },

    async [namespace.actions.REMOVE_MAPPING] ({ commit, state, dispatch }, payload) {
        try {       
            commit(namespace.mutations.SHOW_LOADER, true);  
            commit(namespace.mutations.SET_MAPPINGS_VALUES, await service.removeMapping(
                state[namespace.state.AVAILABLE_JIRA_VALUES],
                state[namespace.state.AVAILABLE_TFS_VALUES],
                payload.mapping,
                state[namespace.state.MAPPINGS_GROUPS]
            ));
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },

    async [namespace.actions.SET_DEFAULT_MAPPING] ({ commit, state, dispatch }, mapping) {
        try {       
            commit(namespace.mutations.UPDATE_MAPPINGS, await service.setMappingAsDefault(
                mapping,
                state[namespace.state.MAPPINGS_GROUPS]              
            ));
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    
    [namespace.actions.SET_UP_SERVICE] ({}, payload) {  
        if (payload.service !== undefined) {
            service = payload.service;
        }
        if (payload.prefix !== undefined) {
            service.backendUrl = payload.prefix;
        }
    },
    [namespace.actions.HANDLE_ERROR] ({ commit, dispatch }, error) {    
        const message = appService.extractMessageFromErrorObject(error);
        commit(namespace.mutations.SHOW_LOADER, false);
        dispatch(
            APP_NAMESPACE.actions.SEND_NOTIFICATION, {
                receiver: 'MessageBox', 
                payload: {title: ERROR_MESSAGE_TITLE, message: message}
            }, 
            {root: true}
        );
    },
    [namespace.actions.SET_SELECTED_JIRA_FIELD]({commit, dispatch}, selectedValue){
        commit(namespace.mutations.SET_SELECTED_JIRA_FIELD, selectedValue);
    },
    [namespace.actions.SET_SELECTED_TFS_FIELD]({commit, dispatch}, selectedValue){
        commit(namespace.mutations.SET_SELECTED_TFS_FIELD, selectedValue);
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/fieldsMapping/actions.js